export default __webpack_public_path__ + "static/2-a505b14b2ba59f3c22e3a1e10d4bce36.jpeg";